"use strict";

import ReactDOM from 'react-dom';
import React from 'react';

import { MarketGetPairStat } from 'api/tradeAPICall';

import { _I_, defineSimpleTerm } from 'components/locs';
import MoneyUtil from 'components/moneyUtil';
import { GraphController } from 'components/generics';


// LogStream.enable("VIEWPRICEHISTORYGRAPH");
const loggerPriceHistory = LogStream("VIEWPRICEHISTORYGRAPH");

export default class ViewPriceHistoryGraph extends React.Component {
  constructor(props)  {
    super(props);

    this.state = {
      "shortRange": true,
      "series_1h":[],
      "series_1d":[],
      "plotOpt": this.getPlotOptions(),
    };
  }


  componentDidMount() {
    this.getPlotData();
  }

  prepareSeries( series )  {
    if (!series || !series.length)
      return [];

    var tradeSeries = series.map( ([ts, price, vol])  =>  ([1000*ts, +MoneyUtil.formatMoney(price), vol]) );
    var volumeSeries = series.map( ([ts, price, vol])  =>  ([1000*ts, vol]) );

    return [volumeSeries, tradeSeries];
  }

  getPlotData() {
    if ( !this.props.market_name )
    {
      this.setState({ "series_1h": [], "series_1d": [] });
      loggerPriceHistory.info( "getPlotData - skipped due to empty market_hash_name" );
      return;
    }

    MarketGetPairStat(
          this.props.appid, this.props.market_name

      ).then( (resp) =>  {
        loggerPriceHistory.info('getPlotData', resp);
        this.setState({
          "series_1h": this.prepareSeries(resp["1h"]),
          "series_1d": this.prepareSeries(resp["1d"])
        });

      }).catch( ( reason ) =>  {
        this.setState({ "series_1h": [], "series_1d": [] });
        reason = Object.assign( {}, reason,
                                {
                                  "message": ("Failed to load price history data:\n"+
                                              reason.message)
                                });

        loggerPriceHistory.error( "getPlotData - Failed (", reason, ")" );
      });
  }

  getPlotOptions()   {
    return {
      title: {  text: _I_("PriceHistoryGraph.plot.title"),  textAlign: 'center'  },
      gridPadding: {  left: 75,  right:45,  top: 45  },
      axesDefaults: {  showTickMarks: false  },
      axes:{
        xaxis:{
          renderer: $.jqplot.DateAxisRenderer,
          pad: 1.1,  padMin: 1.1,  padMax: 1.1,
          tickOptions: {  formatString: '%m-%d %H:%M'  },
        },
        yaxis: {
          pad: 1.1,  padMin: 1.1,  padMax: 1.1,
          tickOptions: {
            formatString: '%0.2f',
            labelPosition:'start',
            showMark: false
          },
          numberTicks: 7,
        }
      },
      grid: {
        gridLineColor: '#1b2939',
        borderColor: '#1b2939',
        background: '#101822'
      },
      cursor: {
        show: true,
        zoom: true,
        showTooltip: false
      },
      highlighter: {
        show: true,
        lineWidthAdjust: 2.5,
        sizeAdjust: 5,
        showTooltip: true,
        tooltipLocation: 'n',
        tooltipOffset: 20,
        fadeTooltip: true,
        yvalues: 2,
        formatString: _I_("PriceHistoryGraph.highlighter.format")
      },
      series: [
        {
          pointLabels: {
              show: true
          },
          renderer: $.jqplot.BarRenderer,
          showHighlight: false,
          yaxis: 'y2axis',
          rendererOptions: {
            barWidth: 10,
            barPadding: -10,
            barMargin: 0,
            highlightMouseOver: false
          }
        },
        {
          lineWidth: 3,
          markerOptions:  {  show: false,  style:'circle'  }
        }
      ],
      noDataIndicator: {
        show: true,
        indicator: 'No data',
        axes: {
          xaxis: { min: 0, max: 10, tickInterval: 2, show: false },
          yaxis: { min: 0, max: 12, tickInterval: 3, show: false },
        }
      },
      seriesColors: [ "#273724", "#688F3E" ]
    };
  }


  render() {
    const { plotOpt, shortRange } = this.state;
    const series = this.state[ shortRange ? "series_1h" : "series_1d" ] || [];

    loggerPriceHistory.debug('render', series);

    return (<div>
        <GraphController
            plotOpt={plotOpt}
            plotData={series}
          />

        <button
            type="button"
            className="btn btn-default btn-xs"
            disabled={ this.state.shortRange }
            onClick={ () =>  {  this.setState({ "shortRange": true })  } }
          >{_I_("PriceHistoryGraph.plot.shortRange")}</button>

        <button
            type="button"
            className="btn btn-default btn-xs"
            disabled={ !this.state.shortRange }
            onClick={ () =>  {  this.setState({ "shortRange": false }) } }
          >{_I_("PriceHistoryGraph.plot.wholeRange")}</button>
      </div>);
  }
}


defineSimpleTerm( "PriceHistoryGraph.plot.title",  "Price history",       {
  "ru_RU": "История цен",
  "cs_CZ": "Price history",
  "fr_FR": "Historique des prix",
  "de_DE": "Preisverlauf",
  "it_IT": "Storico prezzi",
  "ko_KR": "거래가 기록",
  "pl_PL": "Historia ceny",
  "pt_PT": "Price history",
  "es_ES": "Historial de precio",
  "zh_CN": "价格历史",
  "zh_TW": "價格歷史"
} );

defineSimpleTerm( "PriceHistoryGraph.highlighter.format",  "At <strong>%s</strong><br /> price <strong>%s</strong><br /> amount <strong>%s</strong><br />",       {
  "ru_RU": "На <strong>%s</strong><br />цена <strong>%s</strong><br />количество <strong>%s</strong><br />",
  "cs_CZ": "At <strong>%s</strong><br /> price <strong>%s</strong><br /> amount <strong>%s</strong><br />",
  "fr_FR": "A <strong>%s</strong><br /> prix <strong>%s</strong><br /> nombre <strong>%s</strong><br />",
  "de_DE": "Bei <strong>%s</strong><br /> Preis <strong>%s</strong><br /> Summe <strong>%s</strong><br />",
  "it_IT": "Al <strong>%s</strong><br /> prezzo <strong>%s</strong><br /> di <strong>%s</strong><br />",
  "ko_KR": "시간<strong>%s</strong><br />가격<strong>%s</strong><br />거래량<strong>%s</strong><br />",
  "pl_PL": "Dnia <strong>%s</strong><br /> cena <strong>%s</strong><br /> ilość <strong>%s</strong><br />",
  "pt_PT": "At <strong>%s</strong><br /> price <strong>%s</strong><br /> amount <strong>%s</strong><br />",
  "es_ES": "A <strong>%s</strong><br /> precio <strong>%s</strong><br /> cantidad <strong>%s</strong><br />",
  "zh_CN": "于 <strong>%s</strong><br /> 价格<strong>%s</strong><br /> 数量 <strong>%s</strong><br />",
  "zh_TW": "於 <strong>%s</strong><br /> 價格<strong>%s</strong><br /> 數量 <strong>%s</strong><br />"
} );

defineSimpleTerm( "PriceHistoryGraph.plot.shortRange",  "Short range",       {
  "ru_RU": "Ближайшее время",
  "cs_CZ": "Short range",
  "fr_FR": "Courte période",
  "de_DE": "Geringe Spanne",
  "it_IT": "Breve periodo",
  "ko_KR": "최근 기록",
  "pl_PL": "Krótki zakres",
  "pt_PT": "Short range",
  "es_ES": "Corto alcance",
  "zh_CN": "短期",
  "zh_TW": "短期"
} );

defineSimpleTerm( "PriceHistoryGraph.plot.wholeRange",  "Whole time",       {
  "ru_RU": "За все время",
  "cs_CZ": "Whole time",
  "fr_FR": "Tout le temps",
  "de_DE": "Gesamte Zeit",
  "it_IT": "Tutti i tempi",
  "ko_KR": "전체 기록",
  "pl_PL": "Całość",
  "pt_PT": "Whole time",
  "es_ES": "Todo el tiempo",
  "zh_CN": "全程",
  "zh_TW": "全程"
} );

